import { Exclude, Expose } from "class-transformer";
import { BaseDiscountDto } from "./CreateDiscountDto";

@Exclude()
export class UpdateDiscountDto extends BaseDiscountDto implements Readonly<UpdateDiscountDto> {
    @Expose()
    discount_attribute_value_bindings: number[];
}
